// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SI-z","hovered":"TI-z","hoverImage":"UI-z","mainImage":"VI-z","imageNoBackground":"WI-z","fullSizeImage":"XI-z"};